(function () {
  'use strict';

  var ready = function (callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  };

  var visibleText = function (element) {
    return (element.textContent || '').replace(/\s+/g, ' ').trim();
  };

  var findTriggerByTarget = function (target) {
    var triggers = document.querySelectorAll('.js-toggle-submenu[data-target]');
    for (var index = 0; index < triggers.length; index += 1) {
      if (triggers[index].getAttribute('data-target') === target) return triggers[index];
    }
    return null;
  };

  var prepareMobileNavigation = function () {
    var triggers = document.querySelectorAll('.js-toggle-submenu[data-target]');
    triggers.forEach(function (trigger, index) {
      var target = trigger.getAttribute('data-target');
      var menu = document.querySelector('.mobile-nav__dropdown[data-parent="' + target + '"]');
      if (!menu) return;
      if (!menu.id) menu.id = 'MobileSubnav-' + index;
      trigger.setAttribute('aria-controls', menu.id);
      trigger.setAttribute('aria-expanded', trigger.classList.contains('is-active') ? 'true' : 'false');
    });

    document.querySelectorAll('.mobile-nav__return-btn').forEach(function (button) {
      button.removeAttribute('aria-expanded');
    });

    var mobileNav = document.getElementById('MobileNav');
    if (!mobileNav || !window.MutationObserver) return;
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        var trigger = mutation.target;
        if (!trigger.matches || !trigger.matches('.js-toggle-submenu[data-target]')) return;
        trigger.setAttribute('aria-expanded', trigger.classList.contains('is-active') ? 'true' : 'false');
      });
    });
    triggers.forEach(function (trigger) {
      observer.observe(trigger, { attributes: true, attributeFilter: ['class'] });
    });
  };

  var handleMobileNavigationClick = function (event) {
    var button = event.target.closest && event.target.closest('.js-toggle-submenu');
    if (!button) return;
    window.setTimeout(function () {
      if (button.classList.contains('mobile-nav__return-btn')) {
        var dropdown = button.closest('.mobile-nav__dropdown');
        if (dropdown) {
          var parentTrigger = findTriggerByTarget(dropdown.getAttribute('data-parent'));
          if (parentTrigger) parentTrigger.setAttribute('aria-expanded', 'false');
        }
        return;
      }
      var target = button.getAttribute('data-target');
      var targetMenu = target && document.querySelector('.mobile-nav__dropdown[data-parent="' + target + '"]');
      button.setAttribute('aria-expanded', targetMenu ? 'true' : 'false');
    }, 20);
  };

  var syncMobileNavigationClose = function () {
    var toggle = document.querySelector('.js-mobile-nav-toggle');
    if (!toggle || toggle.getAttribute('aria-expanded') !== 'false') return;
    document.querySelectorAll('.js-toggle-submenu[data-target]').forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    });
  };

  var cookieWasDismissed = function () {
    return document.cookie.split(';').some(function (item) {
      return item.trim().indexOf('cookieconsent_status=dismiss') === 0;
    });
  };

  var hideCookieBanner = function () {
    document.querySelectorAll('.cc-window[aria-label="cookieconsent"], .cc-window.cc-banner, .cc-window.cc-floating').forEach(function (banner) {
      banner.setAttribute('aria-hidden', 'true');
      banner.hidden = true;
      banner.style.display = 'none';
    });
  };

  var prepareCookieBanner = function () {
    if (cookieWasDismissed()) hideCookieBanner();
    document.addEventListener('click', function (event) {
      var dismiss = event.target.closest && event.target.closest('.cc-dismiss');
      if (!dismiss) return;
      window.setTimeout(function () {
        if (!cookieWasDismissed()) {
          document.cookie = 'cookieconsent_status=dismiss; path=/; max-age=31536000; SameSite=Lax';
        }
        hideCookieBanner();
      }, 30);
    });
  };

  var titleEmbeddedContent = function () {
    document.querySelectorAll('iframe:not([title])').forEach(function (frame) {
      var source = (frame.getAttribute('src') || '').toLowerCase();
      if (source.indexOf('youtube') !== -1 || source.indexOf('youtu.be') !== -1) {
        frame.title = 'Vídeo incorporado';
      } else if (source.indexOf('googletagmanager') !== -1) {
        frame.title = 'Gestor de etiquetas';
      } else {
        frame.title = 'Conteúdo incorporado';
      }
    });
  };

  var describeImages = function () {
    document.querySelectorAll('img:not([alt])').forEach(function (image) {
      var link = image.closest('a');
      var contextualText = link ? visibleText(link) : '';
      if (contextualText) {
        image.alt = contextualText.slice(0, 160);
      } else {
        image.alt = '';
        image.setAttribute('role', 'presentation');
      }
    });
  };

  var labelLayoutHubControls = function () {
    document.querySelectorAll('.lh-slide-wraper .owl-dot[role="button"]').forEach(function (control, index) {
      if (!control.getAttribute('aria-label')) {
        control.setAttribute('aria-label', 'Ir para o slide ' + (index + 1));
      }
    });

    document.querySelectorAll('a[data-lhlink]').forEach(function (link, index) {
      if (link.getAttribute('aria-label') || visibleText(link)) return;
      var image = link.querySelector('img[alt]:not([alt=""])');
      var label = image && image.getAttribute('alt');
      link.setAttribute('aria-label', label || ('Conheça o parceiro ' + (index + 1)));
    });
  };

  var labelIconControls = function () {
    var knownLabels = [
      ['.slick-prev', 'Anterior'],
      ['.slick-next', 'Próximo'],
      ['.close, .modal__close, .drawer__close', 'Fechar'],
      ['.social-sharing a[href*="facebook"]', 'Partilhar no Facebook'],
      ['.social-sharing a[href*="twitter"]', 'Partilhar no X'],
      ['.social-sharing a[href*="pinterest"]', 'Partilhar no Pinterest']
    ];
    knownLabels.forEach(function (entry) {
      document.querySelectorAll(entry[0]).forEach(function (element) {
        if (!element.getAttribute('aria-label') && !visibleText(element)) {
          element.setAttribute('aria-label', entry[1]);
        }
      });
    });

    document.querySelectorAll('a[href], button').forEach(function (element) {
      if (element.getAttribute('aria-label') || visibleText(element)) return;
      var title = element.getAttribute('title');
      var image = element.querySelector('img[alt]:not([alt=""])');
      var label = title || (image && image.getAttribute('alt'));
      if (label) element.setAttribute('aria-label', label.trim());
    });
  };

  var activateAboutVideo = function (trigger) {
    var component = trigger.closest('[data-navega-about-video]');
    if (!component || component.classList.contains('is-playing')) return;

    var frame = component.querySelector('[data-navega-about-video-frame]');
    var iframe = frame && frame.querySelector('iframe[data-src]');
    var source = iframe && iframe.getAttribute('data-src');
    if (!frame || !iframe || !source) return;

    component.classList.add('is-playing');
    trigger.setAttribute('aria-expanded', 'true');
    frame.hidden = false;
    trigger.hidden = true;

    iframe.addEventListener('load', function () {
      iframe.focus();
    }, { once: true });
    iframe.setAttribute('src', source);
  };

  ready(function () {
    document.addEventListener('click', handleMobileNavigationClick, true);
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest && event.target.closest('[data-navega-about-video-trigger]');
      if (!trigger) return;
      event.preventDefault();
      activateAboutVideo(trigger);
    });
    document.addEventListener('click', function (event) {
      if (event.target.closest && event.target.closest('.js-mobile-nav-toggle')) {
        window.setTimeout(syncMobileNavigationClose, 20);
      }
    }, true);
    prepareMobileNavigation();
    prepareCookieBanner();
    titleEmbeddedContent();
    describeImages();
    labelIconControls();
    labelLayoutHubControls();
    window.setTimeout(labelLayoutHubControls, 1000);
    window.setTimeout(labelLayoutHubControls, 3000);
  });
}());
